import React, { useState } from 'react';
import { MyDesigns } from '../components/design/MyDesigns';
import { DealerCustomerDesigns } from '../components/design/DealerCustomerDesigns';
import { SharedDesigns } from '../components/design/SharedDesigns';
import { UserIcon, UsersIcon, ShareIcon, SearchIcon, FilterIcon, PlusIcon, PencilRulerIcon, MapPinIcon, BellIcon, ChevronDownIcon } from 'lucide-react';
import { LanguageSelector } from '../components/LanguageSelector';
export function DesignPage() {
  const [activeTab, setActiveTab] = useState('myDesigns');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedDealer, setSelectedDealer] = useState('all');
  const [selectedRegion, setSelectedRegion] = useState('all');
  const [selectedModel, setSelectedModel] = useState('all');
  const handleNewDesign = () => {
    // Functionality for creating a new design would go here
    console.log('Creating new design');
  };
  return <div className="flex flex-col h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950" data-id="element-8934">
      {/* Header with navigation */}
      <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 border-b border-blue-800/30 relative z-10" data-id="element-8935">
        <div className="flex items-center justify-between p-6" data-id="element-8936">
          <div className="flex items-center" data-id="element-8937">
            <div className="p-2 mr-3 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-lg" data-id="element-8938">
              <PencilRulerIcon size={20} className="text-white" data-id="element-8939" />
            </div>
            <h1 className="text-xl font-bold text-white" data-id="element-8940">Design</h1>
          </div>
          <div className="flex items-center space-x-3" data-id="element-8941">
            <LanguageSelector data-id="element-8942" />
            <div className="relative" data-id="element-8943">
              <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-8944">
                <BellIcon size={20} data-id="element-8945" />
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-8946">
                  2
                </span>
              </button>
            </div>
            <div className="flex items-center bg-white/10 hover:bg-white/15 rounded-full pl-2 pr-3 py-1 cursor-pointer transition-colors" data-id="element-8947">
              <div className="bg-gradient-to-br from-blue-600 to-indigo-700 rounded-full w-8 h-8 flex items-center justify-center mr-2" data-id="element-8948">
                <UserIcon size={16} className="text-white" data-id="element-8949" />
              </div>
              <span className="text-white text-sm font-medium hidden sm:block" data-id="element-8950">
                Daniel Alejandro
              </span>
              <ChevronDownIcon size={16} className="text-blue-300 ml-1 hidden sm:block" data-id="element-8951" />
            </div>
          </div>
        </div>
      </div>
      <div className="p-6 flex-1 overflow-auto" data-id="element-8952">
        <div className="mb-6" data-id="element-8953">
          {/* Tabs */}
          <div className="flex border-b border-blue-800 mt-2" data-id="element-8954">
            <TabButton active={activeTab === 'myDesigns'} onClick={() => setActiveTab('myDesigns')} icon={<UserIcon size={18} data-id="element-8956" />} label="My designs" data-id="element-8955" />
            <TabButton active={activeTab === 'dealerCustomer'} onClick={() => setActiveTab('dealerCustomer')} icon={<UsersIcon size={18} data-id="element-8958" />} label="Dealer & Customer Designs" data-id="element-8957" />
            <TabButton active={activeTab === 'shared'} onClick={() => setActiveTab('shared')} icon={<ShareIcon size={18} data-id="element-8960" />} label="Shared with me" data-id="element-8959" />
          </div>
        </div>
        {/* Action bar with search and filters */}
        <div className="flex flex-wrap justify-between items-center mb-6 gap-4" data-id="element-8961">
          <div className="flex gap-4 flex-wrap" data-id="element-8962">
            <div className="relative" data-id="element-8963">
              <input type="text" placeholder="Search by code, name, type or user" className="pl-10 pr-4 py-2.5 rounded-lg bg-white/10 border border-blue-800 text-white placeholder-blue-300 w-72 focus:outline-none focus:ring-2 focus:ring-blue-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-8964" />
              <SearchIcon className="absolute left-3 top-3 text-blue-300" size={18} data-id="element-8965" />
            </div>
            <select className="px-4 py-2.5 rounded-lg bg-white/10 border border-blue-800 text-white appearance-none pr-8 w-48" value={selectedDealer} onChange={e => setSelectedDealer(e.target.value)} style={{
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center'
          }} data-id="element-8966">
              <option value="all" data-id="element-8967">Select dealer</option>
              <option value="hmb" data-id="element-8968">HMB Irrigation</option>
              <option value="weaks" data-id="element-8969">WEAKS MARTIN</option>
              <option value="van" data-id="element-8970">VAN DIEMEN LAND IRRIGATION</option>
              <option value="aisco" data-id="element-8971">AiscoEurope SAU</option>
            </select>
            <select className="px-4 py-2.5 rounded-lg bg-white/10 border border-blue-800 text-white appearance-none pr-8 w-48" value={selectedRegion} onChange={e => setSelectedRegion(e.target.value)} style={{
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center'
          }} data-id="element-8972">
              <option value="all" data-id="element-8973">Select region</option>
              <option value="america" data-id="element-8974">America</option>
              <option value="europe" data-id="element-8975">Europe</option>
              <option value="australia" data-id="element-8976">Australia</option>
              <option value="asia" data-id="element-8977">Asia</option>
              <option value="africa" data-id="element-8978">Africa</option>
            </select>
            <select className="px-4 py-2.5 rounded-lg bg-white/10 border border-blue-800 text-white appearance-none pr-8 w-48" value={selectedModel} onChange={e => setSelectedModel(e.target.value)} style={{
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center'
          }} data-id="element-8979">
              <option value="all" data-id="element-8980">All models</option>
              <option value="cp600" data-id="element-8981">Pivot CP600</option>
              <option value="8120" data-id="element-8982">Pivot 8120</option>
              <option value="linear" data-id="element-8983">Linear</option>
              <option value="corner" data-id="element-8984">Corner Arm</option>
            </select>
          </div>
          <div className="flex gap-3" data-id="element-8985">
            <button onClick={handleNewDesign} className="flex items-center bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors shadow-lg" data-id="element-8986">
              <PlusIcon size={18} className="mr-2" data-id="element-8987" />
              New Design
            </button>
            <button className="flex items-center bg-white/10 hover:bg-white/20 text-white p-2.5 rounded-lg transition-colors" data-id="element-8988">
              <FilterIcon size={18} data-id="element-8989" />
            </button>
          </div>
        </div>
        {/* Tab content */}
        <div className="bg-white rounded-xl shadow-xl overflow-hidden" data-id="element-8990">
          {activeTab === 'myDesigns' && <MyDesigns searchQuery={searchQuery} selectedDealer={selectedDealer} selectedRegion={selectedRegion} selectedModel={selectedModel} data-id="element-8991" />}
          {activeTab === 'dealerCustomer' && <DealerCustomerDesigns searchQuery={searchQuery} selectedDealer={selectedDealer} selectedRegion={selectedRegion} selectedModel={selectedModel} data-id="element-8992" />}
          {activeTab === 'shared' && <SharedDesigns searchQuery={searchQuery} selectedDealer={selectedDealer} selectedRegion={selectedRegion} selectedModel={selectedModel} data-id="element-8993" />}
        </div>
      </div>
    </div>;
}
function TabButton({
  active,
  onClick,
  icon,
  label
}) {
  return <button className={`flex items-center px-6 py-3 font-medium transition-colors ${active ? 'text-white border-b-2 border-white' : 'text-blue-300 hover:text-white'}`} onClick={onClick} data-id="element-8994">
      {icon && <span className="mr-2" data-id="element-8995">{icon}</span>}
      {label}
    </button>;
}